import React from "react"
import { Button } from "react-bootstrap"
import { FormattedMessage, injectIntl } from "react-intl"
import IntlProps from "../../../state/helpers/IntlProps"

type OwnProps = {
    onClick: () => void
    errorMessage: string
}

const RainforestErrorRefreshButton = (props: OwnProps & IntlProps) => {
    
    const handleClick = (e: React.MouseEvent) =>   {
        e.preventDefault()
        props.onClick()
    }

    return <div>
        <strong className="mr-auto">
            <FormattedMessage
                id="common.credit_card.rainforest.error_header"
                defaultMessage="Error"
            /></strong>
        <p className="text-danger">
            {props.errorMessage}
        </p>
        <Button onClick={handleClick}>
            <FormattedMessage
                tagName="div"
                id="common.credit_card.rainforest.refresh_page_btn"
                defaultMessage="Refresh the page"
            />
        </Button>
    </div>
}
export default injectIntl(RainforestErrorRefreshButton)


// WEBPACK FOOTER //
// ./src/common/credit-card/rf-components/RainforestErrorRefreshButton.tsx